import fetch from "../fetch";
import Qs from "qs";

//导航栏列表
export function navList(params) {
  return fetch({
    url: "/nav-list",
    method: "get",
    params
  });
}

//相关产品的数据
export function columnInfo(params) {
  return fetch({
    url: "/column-info",
    method: "get",
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js